import { usePermissions } from '@/features/auth';
import { canManageAuthorisedContacts } from '../utils/authorisedContactLabels';
import { isListPanelFocusable } from '../utils/listPanelFocus';
import { useAuthorisedContacts } from './useAuthorisedContacts';

/**
 * The Add button and every row's Revoke button sit behind the same
 * permission-and-status rule, so `canManage` is the panel's only focusable action.
 */
export function useAgreementAuthorisedContactsPanel(id: string | undefined, status: string | undefined) {
    const { hasPermission } = usePermissions();
    const canManage =
        status !== undefined &&
        canManageAuthorisedContacts(status) &&
        hasPermission({ resource: 'agreement', action: 'authorised_contact.manage' });
    const contacts = useAuthorisedContacts(id);

    return {
        canManage,
        contacts,
        focusablePanel: isListPanelFocusable({
            isLoading: contacts.query.isLoading,
            isError: contacts.query.isError,
            hasFocusableAction: canManage,
            lastPage: contacts.query.data?.meta.lastPage,
        }),
    };
}
